module.exports = __webpack_public_path__ + "img/formMs2.df7d6212.svg";